/* eslint-disable prefer-promise-reject-errors */
import crypto from 'crypto-js'
import crypto_AES from 'crypto-js/aes'
import crypto_utf8 from 'crypto-js/enc-utf8'
import crypto_base64 from 'crypto-js/enc-base64'
import fetcher from './fetchers'

import { CertificateTypes } from './config'

/**
 * 提交用户在获奖后个人信息
 * http://apix.kisops.com/project/744/interface/api/48566
 * @param {object} body 领奖填写信息
 * @param {number} period 比赛期数
 */
export function submitAwardeeInfo(body, period, options = { needDeliver: false }) {
  console.log(body)
  if (!body.real_name) {
    return Promise.reject('请填写名字')
  } else if (!body.phone) {
    return Promise.reject('请填写手机号码')
  } else if (!body.certificate_no) {
    return Promise.reject('请填写证件号码')
  } else if (!body.third_platform_contact) {
    return Promise.reject('请填写QQ/微信')
  // } else if (!body.bank_no) {
  //   return Promise.reject('请填写银行卡号')
  // } else if (!body.bank) {
  //   return Promise.reject('请填写开户行')
  } else if (!/(?:^1[3456789]|^9[28])\d{9}$/.test(body.phone)) {
    return Promise.reject('请填写正确的手机号码')
  } else if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(body.certificate_no) && body.certificate_type === CertificateTypes.IDCARD) {
    return Promise.reject('请填写正确的二代身份证号码')
  } else if (!/^[HMhm]{1}([0-9]{10}|[0-9]{8})$/.test(body.certificate_no) && body.certificate_type === CertificateTypes.GANGAO_PASSPORT) {
    // 港澳居民来往内地通行证
    // 规则： H/M + 10位或6位数字
    // 样本： H1234567890
    return Promise.reject('请填写正确的港澳通行证号码')
  } else if (!/^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/.test(body.certificate_no) && body.certificate_type === CertificateTypes.TAIWAN_PASSPORT) {
    // 规则： 新版8位或18位数字， 旧版10位数字 + 英文字母
    // 样本： 12345678 或 1234567890B
    return Promise.reject('请填写正确的台湾通行证号码')
  } else if (!/^([a-zA-z]|[0-9]){5,17}$/.test(body.certificate_no) && body.certificate_type === CertificateTypes.PASSPORT) {
    // 护照
    // 规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
    // 样本： 141234567, G12345678, P123456
    return Promise.reject('请填写正确的护照号码')
  } else if (options.needDeliver) {
    if (!body.deliver_name) {
      return Promise.reject('请填写收件人')
    } else if (!body.deliver_phone) {
      return Promise.reject('请填写收件电话')
    } else if (!body.deliver_address) {
      return Promise.reject('请填写收件地址')
    }
  }
  // 规则正确
  const key1 = 'exAbZvqtXwFLiwo4' // 服务端分配, 长度是16, 客户端写死
  const iv1 = '5b9f8d90fddfe2e5' // 服务端分配, 长度是16, 客户端写死
  // 客户端每次随机生成, 长度也是16
  const key2 = Array(16).fill(0).map(() => Math.ceil(Math.random() * 100).toString(16)).join('').slice(0, 16)
  const key = crypto_utf8.parse(key1 + key2) // 加密秘钥
  const iv = crypto_utf8.parse(iv1) // 矢量
  const encryptResult = crypto_AES.encrypt(JSON.stringify({
    period,
    author_info: body,
  }), key, {
    iv,
    mode: crypto.mode.CBC, // 注意，要使用cbc， 因为服务端采用的是cbc模式
    padding: crypto.pad.Pkcs7,
  })
  return fetcher.post('/wallpaper/contest/awardee/submit', {
    cipher: crypto_base64.stringify(encryptResult.ciphertext),
    key: key2,
  }).catch((err) => { // err.resp_common !== 0 must exec
    return Promise.reject(err.resp_common.msg)
  })
}

/**
 * 查询获奖人已填写的的信息
 * http://apix.kisops.com/project/744/interface/api/48571
 * @param {{period: number}} params 参数
 * @return {Promise<object>}
 */
export async function fetchAwardeeInfo(params) {
  const result = await fetcher.post('/wallpaper/contest/awardee/info', params)
  const key1 = 'exAbZvqtXwFLiwo4' // 服务端分配, 长度是16, 客户端写死
  const { cipher, key: key2 } = result.data
  const baseResult = crypto.enc.Base64.parse(cipher)
  const ciphertext = crypto.enc.Base64.stringify(baseResult)
  const key = crypto.enc.Utf8.parse(key1 + key2)

  const decrypt = crypto.AES.decrypt(ciphertext, key, {
    iv: crypto.enc.Utf8.parse('5b9f8d90fddfe2e5'),
    mode: crypto.mode.CBC,
    padding: crypto.pad.Pkcs7,
  })
  const author_info_str = decrypt.toString(crypto.enc.Utf8)
  return JSON.parse(author_info_str || '{}')
}

/**
 * 查询用户是否获奖
 * @param {{period: number}} params 参数
 * @return {Promise<{ is_awardee: boolean }>}
 */
export function fetchIfUserIsAwardee({ period }) {
  return fetcher.post('/wallpaper/contest/awardee', { period: Number(period) })
}
